export default __webpack_public_path__ + "static/media/element_spec_32.4b75a66e.webp";